var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotoCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "photo-camera"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 8.32074,
    cy: 7.96155,
    r: 2.24359,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75995 2.08545L6.10899 0.589722H10.5321L11.8811 2.08545H14.218C15.0325 2.08545 15.6923 2.75479 15.6923 3.58117V12.5555C15.6923 13.3819 15.0325 14.0513 14.218 14.0513H2.42309C1.60851 14.0513 0.94873 13.3819 0.94873 12.5555V3.58117C0.94873 2.75479 1.60851 2.08545 2.42309 2.08545H4.75995ZM4.63477 8.06836C4.63477 10.1325 6.28605 11.8077 8.32066 11.8077C10.3553 11.8077 12.0066 10.1325 12.0066 8.06836C12.0066 6.00426 10.3553 4.32905 8.32066 4.32905C6.28605 4.32905 4.63477 6.00426 4.63477 8.06836Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoCamera);
export default __webpack_public_path__ + "static/media/photo-camera.b9a986ae3703fd6f82b4de4dd9a11551.svg";
export { ForwardRef as ReactComponent };